module.exports = __webpack_public_path__ + "img/webank.ed8e9ead.png";